import logger from 'logger';

export const loadModule = (module, initData = {}) => {
    if (!module.default) {
        //eslint-disable-next-line
        console.error(
            'Warning! You are trying to lazy load a module that doesnt export a default.'
        );
    }
    return module.default(initData);
};
export const handleError = error => logger(error);
